import type { RepairOrderQuoteRecommendation } from 'types';

export const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const sortRecommendationsBySortOrder = (
  allRecommendations: RepairOrderQuoteRecommendation[],
) => {
  const sorter = (a: RepairOrderQuoteRecommendation, b: RepairOrderQuoteRecommendation) => {
    return a.sortOrder! - b.sortOrder!;
  };
  const {
    preApprovedWithSortOrder,
    preApproveWithoutSortOrder,
    additionalWithSortOrder,
    additionalWithoutSortOrder,
  } = allRecommendations.reduce<{
    preApprovedWithSortOrder: RepairOrderQuoteRecommendation[];
    preApproveWithoutSortOrder: RepairOrderQuoteRecommendation[];
    additionalWithSortOrder: RepairOrderQuoteRecommendation[];
    additionalWithoutSortOrder: RepairOrderQuoteRecommendation[];
  }>(
    (acc, rec) => {
      if (rec.preApproved && rec.sortOrder) {
        acc.preApprovedWithSortOrder.push(rec);
      } else if (rec.preApproved && !rec.sortOrder) {
        acc.preApproveWithoutSortOrder.push(rec);
      } else if (!rec.preApproved && rec.sortOrder) {
        acc.additionalWithSortOrder.push(rec);
      } else {
        acc.additionalWithoutSortOrder.push(rec);
      }

      return acc;
    },
    {
      preApprovedWithSortOrder: [],
      preApproveWithoutSortOrder: [],
      additionalWithSortOrder: [],
      additionalWithoutSortOrder: [],
    },
  );

  const preApproved = preApprovedWithSortOrder.sort(sorter);
  const additional = additionalWithSortOrder.sort(sorter);

  return [
    ...preApproved,
    ...additional,
    ...preApproveWithoutSortOrder,
    ...additionalWithoutSortOrder,
  ];
};
